import { collection, getDocs, query, where } from '@firebase/firestore';
import { db } from './firebase';
import { COLLECTIONS } from './collections';
import { ServiceArea } from '../types';
import { mapDocs } from '@utils/firestore';
import { ServiceAreaSchema } from '../schemas/firestoreSchemas';

export const serviceAreasApi = {
  // Active service areas only — inactive areas are kept around for history
  // but never gate user access.
  async getActive(): Promise<ServiceArea[]> {
    const q = query(collection(db, COLLECTIONS.SERVICE_AREAS), where('active', '==', true));
    const snapshot = await getDocs(q);
    return mapDocs(snapshot, ServiceAreaSchema);
  },
};
